module.exports = "../images/newsletter-image.jpg?v=22cb9cb";